import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { FaBell, FaListUl } from "react-icons/fa";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import MobilePageLayout from "./MobilePageLayout";
import MobileHomeKpiTile from "./MobileHomeKpiTile";
import PushHealthAlert from "./PushHealthAlert";
import { useMobileHomeMetrics } from "./useMobileHomeMetrics";
import {
  dismissHomePushBanner,
  getPushHealth,
  isHomePushBannerDismissed,
} from "../shared/utils/pushHealth";

const AppHome = ({ setCookies, saveUser }) => {
  const storedUser = localStorage.getItem("user");
  const { t } = useTranslation();
  const history = useHistory();
  const { token, ...user } = storedUser ? JSON.parse(storedUser) : {};
  const {
    unreadNotificationsCount,
    criticalFillingContainersCount,
    containersLoading,
    monitoringEnabled,
    notificationsLoading,
  } = useMobileHomeMetrics();

  const [homeBannerDismissed, setHomeBannerDismissed] = useState(() =>
    isHomePushBannerDismissed(),
  );

  const pushHealth = useMemo(
    () =>
      getPushHealth({
        user: storedUser ? JSON.parse(storedUser) : {},
        fcmTokenCookie: Cookies.get("fcmToken"),
      }),
    [storedUser],
  );

  const showPushBanner = pushHealth.unhealthy && !homeBannerDismissed;

  const kpiGridClassName = monitoringEnabled
    ? "mobile-home-kpi-grid"
    : "mobile-home-kpi-grid mobile-home-kpi-grid-single";

  const handleDismissPushBanner = () => {
    dismissHomePushBanner();
    setHomeBannerDismissed(true);
  };

  return (
    <MobilePageLayout
      title="Akanthas"
      pageClassName="installation-list-page mobile-home-page"
      mainClassName="mobile-home-main"
      setCookies={setCookies}
      saveUser={saveUser}
    >
      <header className="mobile-home-hero">
        <p className="mobile-home-greeting">
          {t("mobile_home_greeting", { name: user?.firstName || "" })}
        </p>
      </header>

      {showPushBanner ? (
        <PushHealthAlert
          status={pushHealth.status}
          onDismiss={handleDismissPushBanner}
          onOpenSettings={() => history.push("/app/settings")}
          className="mobile-home-push-health"
        />
      ) : null}

      <section className="mobile-home-section">
        <h2 className="mobile-home-section-title">
          {t("mobile_home_overview")}
        </h2>
        <div className={kpiGridClassName}>
          <MobileHomeKpiTile
            value={unreadNotificationsCount}
            label={t("mobile_home_kpi_unread")}
            icon={FaBell}
            highlight={unreadNotificationsCount > 0}
            loading={notificationsLoading}
            onClick={() => history.push("/app/notifications")}
          />
          {monitoringEnabled && (
            <MobileHomeKpiTile
              value={criticalFillingContainersCount}
              label={t("mobile_home_kpi_critical_filling", {
                count: criticalFillingContainersCount,
              })}
              icon={FaListUl}
              highlight={criticalFillingContainersCount > 0}
              loading={containersLoading}
              onClick={() => history.push("/app/collect")}
            />
          )}
        </div>
        {!notificationsLoading &&
          !containersLoading &&
          unreadNotificationsCount === 0 &&
          (!monitoringEnabled || criticalFillingContainersCount === 0) && (
            <p className="mobile-home-kpi-none">{t("mobile_home_kpi_none")}</p>
          )}
      </section>
    </MobilePageLayout>
  );
};

export default AppHome;
